import moment from 'moment'
import arraySort from 'array-sort'

module.exports = {
	randomId() {
	  var text = "";
	  var chars = "23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz";
	  for (var i = 0; i < 17; i++)
	    text += chars.charAt(Math.floor(Math.random() * chars.length));
	  return text;
	},
  prettyTime(date, format='D MMMM YYYY [à] H:mm') {
    return (date) ? moment(date).format(format) : "";
  }
};


// WEBPACK FOOTER //
// ./src/helpers.js